module.exports = __webpack_public_path__ + "img/card-BAFAD7.140d0434.png";